import { TransactionStellarUri} from '././stellar-uri/transaction-stellar-uri';
import {PayStellarUri } from '././stellar-uri/pay-stellar-uri'
import {Transaction } from '@stellar/stellar-sdk';

export function createSep7URI(stellarTx:Transaction,pubkey:string):string {

    const uri = TransactionStellarUri.forTransaction(stellarTx);
    uri.pubkey = pubkey;
   
    return uri.toString() 
}

export function createPayUri(destination:string){

    const uri = PayStellarUri.forDestination(destination);
    return uri

}